<template>
  <div id="Password">
    <Navbar :title="$t('交易密码')" />
    <div class="wrap">
      <LoginForm isLabel :formList="formList" confirmText="newAdd.Submit" @submit="onSubmit">
        <template #read>
          <div class="text">{{ $t("My.PersonalInformation.Password.Text") }}</div>
        </template>
        <template #cancel>
          <div></div>
        </template>
      </LoginForm>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/JNav";
import LoginForm from "@/view/login/components/form.vue";
import { SETTING_PAY_PDW } from "@/api"
import {
  Toast,
} from "vant";

export default {
  name: "portrait",
  components: {
    [Toast.name]: Toast,
    Navbar,
    LoginForm,
  },
  data() {
    return {
      userInfo: {},
      formList: [{
        key: "newpass",
        icon: "icon-mima",
        label: "My.PersonalInformation.Password.ConfirmPasswordNote",
      }, {
        key: "confirmpass",
        icon: "icon-mima",
        label: "确认新密码",
      }]
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    onSubmit(values) {
      const { oldpass, newpass, confirmpass } = values;
      if (this.userInfo.setpaypass > 0) {
        if (!oldpass) return Toast(this.$t('My.PersonalInformation.Password.oldPass'))
      }
      if (!newpass) return Toast(this.$t('My.PersonalInformation.Password.ConfirmPasswordNote'));
      if (!confirmpass) return Toast(this.$t('确认新密码'));
      if (newpass != confirmpass) return Toast(this.$t('两次密码不一致'))
      Toast.loading({ duration: 0 });
      SETTING_PAY_PDW({ oldpass, newpass }).then(res => {
        const { ret, msg } = res.data
        Toast.clear();
        if (ret == 1) {
          Toast(msg)
          setTimeout(() => {
            this.getUserInfo();
            this.$router.back()
          }, 1000)
          return
        }
        return Toast(msg)
      })

    },
    getUserInfo() {
      Toast.loading({
        forbidClick: true,
        duration: 0,
      });
      this.$api.getUserInfo((res) => {
        Toast.clear();
        this.userInfo = res;
        if (res.setpaypass > 0) {
          this.formList = [{
            key: "oldpass",
            icon: "icon-mima",
            label: "My.PersonalInformation.Password.oldPass",
          }, ...this.formList]
        }
      }, (err) => {
        Toast.clear();
        this.$toast(err);
      });
    },
  },
};
</script>

<style lang="less" scoped>
#Password {
  min-height: 100vh;
  overflow: hidden;
  background: #F5F5F9;

  .wrap {
    padding: 10px 10px 18px;
  }

  .text {
    color: #5e5e5e;
    font-size: 0.75rem;
    margin-top: calc(20rem / 16);
  }

  /deep/ .form_list {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .van-cell {
      background-color: #efefef !important;
      padding: 0 20px;
      border-radius: 100px;

      .van-field__body {
        height: 44px;
        line-height: 44px;
        background-color: transparent;
        padding: 0 0 0 10px;
      }

      input {
        color: #333;
      }
    }

    .iconfont {
      color: #a5a5a5;
    }

    .confirm {
      color: #fffefe !important;
      font-size: calc(14rem / 16);
      border-radius: calc(100rem / 16) !important;
      height: calc(44rem / 16);
      text-align: center;
      margin-top: calc(30rem / 16);
      text-shadow: 0 1px 1px #5f4a21;
      background: linear-gradient(90deg, #18b38d, #35d49a);
      transition: all .3s ease;
      padding: 4px 10px;
      border-color: #1989fa !important;
    }
  }

}
</style>